import { Modal } from "antd";
import { useIntl } from "react-intl";
import { AddEntityToSeasonDataTable } from "./AddEntityToSeasonDataTable";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  reloadData: () => unknown;
  existingSeasonEntityIdSet: Set<string>;
};

export const AddEntityToSeasonModal = ({ isOpen, setIsOpen, reloadData, existingSeasonEntityIdSet }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      open={isOpen}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={() => setIsOpen(false)}
      width={1200}
      title={formatMessage({ id: "entity.add" })}
      cancelText={formatMessage({ id: "cancel" })}
    >
      <AddEntityToSeasonDataTable existingSeasonEntityIdSet={existingSeasonEntityIdSet} reloadData={reloadData} />
    </Modal>
  );
};
